import { createClient } from '@supabase/supabase-js'

//const supabaseUrl = 'http://localhost:8000'
//const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyAgCiAgICAicm9sZSI6ICJhbm9uIiwKICAgICJpc3MiOiAic3VwYWJhc2UtZGVtbyIsCiAgICAiaWF0IjogMTY0MTc2OTIwMCwKICAgICJleHAiOiAxNzk5NTM1NjAwCn0.dc_X5iR_VP_qT0zsiyj_I_OZ2T9FtRU2BBNWN8Bu4GE'

const supabaseUrl = 'https://v160-251-212-228.aadv.static.cnode.jp:9000'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICJyb2xlIjogImFub24iLAogICJpc3MiOiAic3VwYWJhc2UiLAogICJpYXQiOiAxNzA1Njc2NDAwLAogICJleHAiOiA0ODYxNDMwNDkxCn0.XBf8oJs-2dThwMjXqEyiL0R01VVRVNAJcXror6jwocE'
export const supabase = createClient(supabaseUrl, supabaseAnonKey)